import { Incident } from '@collector/sportsapi-types'

import { getDatabase } from '../instance'
import { Tables } from '../tables'
import { getTable, upsertTableItem } from '../utils'

export type IncidentsRequirePointingPositionRecord = {
  eventId: number
  incidents: Incident['id'][]
}

type IncidentsRequirePointingPositionRecordUpdate = Omit<
  IncidentsRequirePointingPositionRecord,
  'eventId'
>

export function upsert(
  eventId: number,
  incidentIds: Incident['id'][],
): Promise<void> {
  const database = getDatabase()

  return upsertTableItem<IncidentsRequirePointingPositionRecordUpdate>(
    database,
    Tables.INCIDENTS_REQUIRE_POINTING_POSITION,
    eventId,
    {
      incidents: incidentIds,
    },
  )
}

export async function deleteIncident(
  eventId: number,
  incidentId: number,
): Promise<void> {
  const database = getDatabase()
  const tableName = Tables.INCIDENTS_REQUIRE_POINTING_POSITION

  await database.transaction('rw', tableName, async () => {
    const record = await get(eventId)
    const currentIncidentsValue = record?.incidents ?? []
    const newIncidentsValue = currentIncidentsValue.filter(
      (currentIncidentId) => currentIncidentId !== incidentId,
    )

    return upsertTableItem<IncidentsRequirePointingPositionRecordUpdate>(
      database,
      tableName,
      eventId,
      {
        incidents: newIncidentsValue,
      },
    )
  })
}

export function get(
  eventId: number,
): Promise<IncidentsRequirePointingPositionRecord | undefined> {
  const table = getTable(Tables.INCIDENTS_REQUIRE_POINTING_POSITION)

  return table.get(eventId)
}

export function remove(eventId: number): Promise<void> {
  const table = getTable(Tables.INCIDENTS_REQUIRE_POINTING_POSITION)

  return table.delete(eventId)
}
